import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IUser } from '../../models';
import { RootState } from '../rootReducer';

export interface IUserState {
    user: IUser;
}

export const initialState: IUserState = {
    user: {
        amr: [],
        auth_time: NaN,
        email: '',
        family_name: '',
        given_name: '',
        idp: '',
        preferred_username: '',
        sid: '',
        sub: '',
        xero_userid: '',
    },
};

const name = 'user';

const userSlice = createSlice({
    initialState,
    name,
    reducers: {
        updateUser(state, action: PayloadAction<IUser>) {
            state.user = action.payload;
        },
    },
});

export const { updateUser } = userSlice.actions;

export const userSelectors = {
    user: (state: RootState) => state.user.user,
};

export default userSlice.reducer;
